export default __webpack_public_path__ + "static/media/fpah0004.92d4c35c.png";